import classNames from "classnames"
import { InputHTMLAttributes, Ref, forwardRef } from "react"

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    css?: any
}

export const Input = forwardRef(function InputFC(props: InputProps, ref: Ref<HTMLInputElement>) {
    const { className, ...otherProps } = props

    return (
        <input
            ref={ref}
            className={classNames(
                "h-[46px] border border-gray-light p-3 outline-none focus:border-gray-shuttle disabled:border-transparent disabled:bg-gray-bg",
                className
            )}
            {...otherProps}
        />
    )
})
